// const LoginIndexPage = resolve => require(['../views/login.vue'], resolve)
import LoginIndexPage from '../views/login.vue'
const LoginRouter = {}

LoginRouter.routers = [{
  path: '/login',
  component: LoginIndexPage,
  meta: {
    title: 'GASA-Login',
    auth: false,
    access: {
      module: 'login',
      page: 'login'
    }
  }
}
]

export default LoginRouter



// WEBPACK FOOTER //
// ./src/pages/login/routers/login.router.js